import React, { useEffect, useRef } from 'react'
// scroll to top when routing - without breaking accessibility
const OnRouteChangeWorker = ({ location, action }) => {
  const prevLocation = useRef('')

  useEffect(() => {
    if (location.pathname !== prevLocation.current) {
      prevLocation.current = location.pathname
      action()
    }
  })

  return null
}

const defaultAction = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  })
}

export default function OnRouteChange({ location, action = defaultAction }) {
  return <OnRouteChangeWorker location={location} action={action} />
}
